import styled from 'styled-components';
import { IThemeProvider, ITheme } from '../../styles/theme';

interface ITabButton {
  theme: ITheme;
  isSelected?: boolean;
}

export const TabsCont = styled.div`
  position: relative;
  display: inline-flex;
  width: fit-content;
  gap: 2px;
  padding: 3px;
  box-sizing: border-box;
  ${({ theme }: IThemeProvider) => `
    border-radius: ${theme.layout.spacing.mili};
    background: rgba(24, 58, 96, 0.07);
  `}
`;

export const TabButton = styled.div<ITabButton>`
  font-size: 14px;
  line-height: 20px;
  padding: 6px 14px;
  border-radius: 9px;
  cursor: pointer;
  white-space: nowrap;
  user-select: none;
  transition: background 0.15s, color 0.15s, box-shadow 0.15s;

  ${({ theme, isSelected }: ITabButton) => `
    background: ${isSelected ? theme.colors.neutral.primary[0] : 'transparent'};
    color: ${isSelected ? theme.colors.secondary[100] : theme.colors.neutral.primary[70]};
    font-weight: ${isSelected ? 600 : 400};
    box-shadow: ${
      isSelected ? '0 1px 2px rgba(24, 58, 96, 0.12), 0 1px 1px rgba(24, 58, 96, 0.06)' : 'none'
    };

    &:hover {
      color: ${theme.colors.secondary[100]};
    }
  `}
`;

export const TabGroupSectionCont = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
`;
